const password = {
    path: 'password',
    component: resolve => require(['@/pages/admin/user_info/password'], resolve)
}

export default password